import { useQuery } from "@apollo/client/react";
import { SystemSettingsDocument } from "@/graphql/generated/operations";
import { imageDataUrl } from "@/lib/image-data-url";

// The platform's logo from systemSettings (uploaded in Branding), as an <img src>, or null when
// none is stored and the sidebar keeps drawing the app name as text. Same query document as
// useAppName, so Apollo answers both from one request and one cache entry.
export function useBrandLogo(): string | null {
  const { data } = useQuery(SystemSettingsDocument);
  return imageDataUrl(data?.systemSettings?.logo);
}
